<template>
    <Dialog
        v-model:visible="modalState.opened"
        append-to="#app"
        class="w-10/12 sm:w-3/4 md:w-1/2 lg:w-2/5"
        modal
        :draggable="false"
        :dismissable-mask="true"
        :data-testid="testId"
    >
        <template #header>
            <div
                class="title"
                data-testid="dialog-title"
            >{{ title }}</div>
        </template>

        <div data-testid="dialog-description">
            {{ description }}
        </div>

        <div
            v-if="withReason"
            class="mt-6"
        >
            <Textarea
                v-model="reason"
                rows="2"
                auto-resize
                placeholder="Reason"
                fluid
                size="small"
            />
        </div>

        <template #footer>
            <div class="footer">
                <Button
                    :label="t('common.cancel')"
                    severity="secondary"
                    :data-testid="`${testId}-cancel`"
                    @click="cancel"
                />
                <Button
                    :label="t('common.confirm')"
                    :loading="isLoading"
                    severity="danger"
                    :data-testid="`${testId}-confirm`"
                    v-bind="confirmButtonProps"
                    @click="submit"
                />
            </div>
        </template>
    </Dialog>
</template>

<script setup lang="ts">
import useError from '@/composables/error/useError'
import { useI18n } from '@/composables/i18n'
import useModal, { type ConfirmModalProps } from '@/composables/modal'
import { ref } from 'vue'

const { modalState } = useModal()

const props = defineProps<ConfirmModalProps>()

const { t } = useI18n()

const emit = defineEmits<{
    (e: 'success', reason?: string): void
    (e: 'cancel'): void
}>()

const { handleApiError } = useError()

const reason = ref('')

const cancel = () => {
    emit('cancel')
}

const { call, isLoading } = props.apiCallInstance || {}

const submit = async () => {
    try {
        if (props.apiCallInstance && typeof call === 'function') {
            await call()
        }
        emit('success', props.withReason ? reason.value : undefined)
    } catch (e: unknown) {
        handleApiError(e)
    }
}
</script>
